import { fetch, post } from "./base";

export const featchBgVideos = async (cache = true) => {
  return fetch("/templatevideos/", { cache });
};
export const featchUserBgVideos = async (userId, cache = false) => {
  return fetch(`/userbgvideo?userId=${userId}`, { cache });
};

export const removeUserVideo = (userId, id) => {
  return post("/delete_uservideo/" + userId + "/" + id + "/");
};
